import axios from 'axios'
import u from '@/utils'

const state = {
  kpi: []
}

const mutations = {
  setKpi(state, kpi) {
    state.kpi = kpi
  }
}

const actions = {
  async fetchKpi({ commit }) {
    let response = await axios.get('/api/v1/kpis')
    let kpis = [...response.data._embedded.kPIModels]
    kpis = kpis.map(kpi => u.processResp(kpi))
    commit('setKpi', kpis)
    return kpis
  }
}

export default {
  state,
  actions,
  mutations
}
